import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { UPLOAD_EXPERTS_STEPS_DEFAULTS } from "@/puck/defaults/uploadExpertsStepsDefaults";
import { NumberedStepsBlock } from "@/puck/landing/numberedStepsBlock";

export const stepsConfigs: Pick<LandingComponents, "NumberedSteps"> = {
  NumberedSteps: {
    label: "Numbered steps",
    fields: {
      listStyle: {
        type: "select",
        label: "List style",
        options: [
          { label: "Numbered", value: "numbered" },
          { label: "Bullets", value: "bullets" },
        ],
      },
      items: {
        type: "array",
        label: "Steps",
        getItemSummary: (item) => item.text.slice(0, 48),
        defaultItemProps: { text: "Step description" },
        arrayFields: {
          text: { type: "text", contentEditable: true },
        },
      },
    },
    defaultProps: {
      listStyle: "numbered",
      items: UPLOAD_EXPERTS_STEPS_DEFAULTS,
    },
    render: NumberedStepsBlock,
  },
};
